import React from 'react'
import './css/ContactusBanner.css'
export default function ContactusBanner({title, description}) {
    return (
        <div className='contactus-banner'>
            <div className='customcontainer' style={{display:'flex',alignItems:'center', justifyContent:'center'}}>
                <div className='contactusSection'>
                    <h2 data-aos="fade-up">{title || ''}
                    </h2>
                    <p data-aos="fade-up">{description || ''}</p>
                </div>
            </div>
        </div>
    )
}
